import { render, staticRenderFns } from "./BuildAsmtActions.vue?vue&type=template&id=54e53ba3&class=build-position"
import script from "./BuildAsmtActions.vue?vue&type=script&lang=js"
export * from "./BuildAsmtActions.vue?vue&type=script&lang=js"
import style0 from "./BuildAsmtActions.vue?vue&type=style&index=0&id=54e53ba3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports